import { objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import 'react';
import { Link } from '../../Link/Link.js';
import { ImageMapLinkEditor } from './ImageMapLinkEditor/ImageMapLinkEditor.js';
import { jsx } from '@emotion/react';

var _excluded = ["children", "path"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageMapLink(_ref) {
  var children = _ref.children,
    path = _ref.path,
    linkProps = _objectWithoutProperties(_ref, _excluded);
  return jsx(ImageMapLinkEditor, {
    path: path
  }, jsx(StyledLink, linkProps, children || ' '));
}
var StyledLink = /*#__PURE__*/_styled(Link, process.env.NODE_ENV === "production" ? {
  target: "ehqfrny0"
} : {
  target: "ehqfrny0",
  label: "StyledLink"
})(process.env.NODE_ENV === "production" ? {
  name: "a4hmbt",
  styles: "position:absolute"
} : {
  name: "a4hmbt",
  styles: "position:absolute",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlTWFwTGluay50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUIrQiIsImZpbGUiOiJJbWFnZU1hcExpbmsudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgRG9jdW1lbnRQYXRoIH0gZnJvbSAnLi4vLi4vLi4vdHlwZXMnO1xuaW1wb3J0IHsgTGluaywgTGlua1Byb3BzIH0gZnJvbSAnLi4vLi4vTGluay9MaW5rJztcbmltcG9ydCB7IEltYWdlTWFwTGlua0VkaXRvciB9IGZyb20gJy4vSW1hZ2VNYXBMaW5rRWRpdG9yJztcblxuZXhwb3J0IGludGVyZmFjZSBJbWFnZU1hcExpbmtQcm9wcyBleHRlbmRzIExpbmtQcm9wcyB7XG4gIHBhdGg6IERvY3VtZW50UGF0aDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIEltYWdlTWFwTGluayh7XG4gIGNoaWxkcmVuLFxuICBwYXRoLFxuICAuLi5saW5rUHJvcHNcbn06IFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPEltYWdlTWFwTGlua1Byb3BzPikge1xuICByZXR1cm4gKFxuICAgIDxJbWFnZU1hcExpbmtFZGl0b3IgcGF0aD17cGF0aH0+XG4gICAgICA8U3R5bGVkTGluayB7Li4ubGlua1Byb3BzfT57IGNoaWxkcmVuIHx8ICcgJyB9PC9TdHlsZWRMaW5rPlxuICAgIDwvSW1hZ2VNYXBMaW5rRWRpdG9yPlxuICApO1xufVxuXG5jb25zdCBTdHlsZWRMaW5rID0gc3R5bGVkKExpbmspYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { ImageMapLink };
//# sourceMappingURL=ImageMapLink.js.map
